'use strict';

import { Entity } from '../Entity';

export class IndMedicare extends Entity {
  protected indMedicareId;
  protected indMedicareNumber;
  protected indMedicareParta;
  protected indMedicarePartb;
  protected indMedicareName;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.indMedicareId = data.indMedicareId;
    this.indMedicareNumber = data.indMedicareNumber;
    this.indMedicareName = data.indMedicareName;
    if (data.indMedicareParta) {
      const indMedicareParta = data.indMedicareParta.date.split(' ')[0].split('-');
      this.indMedicareParta =
        indMedicareParta[1] + '/' + indMedicareParta[2] + '/' + indMedicareParta[0];
    }

    if (data.indMedicarePartb) {
      const indMedicarePartb = data.indMedicarePartb.date.split(' ')[0].split('-');
      this.indMedicarePartb =
        indMedicarePartb[1] + '/' + indMedicarePartb[2] + '/' + indMedicarePartb[0];
    }
  }

  public getIndMedicareId() {
    return this.indMedicareId;
  }

  public getIndMedicareNumber() {
    return this.indMedicareNumber.replaceAll('-', '');
  }

  public setIndMedicareNumber(indMedicareNumber) {
    this.indMedicareNumber = indMedicareNumber;

    return this;
  }

  public getIndMedicareParta() {
    return this.indMedicareParta;
  }

  public setIndMedicareParta(indMedicareParta) {
    this.indMedicareParta = indMedicareParta;

    return this;
  }

  public getIndMedicarePartb() {
    return this.indMedicarePartb;
  }

  public setIndMedicarePartb(indMedicarePartb) {
    this.indMedicarePartb = indMedicarePartb;

    return this;
  }

  public getIndMedicareName() {
    return this.indMedicareName;
  }

  public setIndMedicareName(indMedicareName) {
    this.indMedicareName = indMedicareName;

    return this;
  }

  public makeMedicareCard() {
    const medicareCard =
      "<div class='rounded text-center' style='padding:15px;color:#ffffff;background:#143E97'><b>MEDICARE HEALTH INSURANCE</b></div>" +
      "<div style='background:white;padding:20px'>" +
      '<div style="font-size:9pt">Medicare Number</div>' +
      '<div style="margin-bottom:30px;"><b>' +
      (this.indMedicareNumber || '') +
      '</b></div>' +
      '<div style="width:50%; display:inline-block">' +
      '<div style="font-size:9pt">Entitled to</div>' +
      '<div><b>PART-A</b></div>' +
      '<div><b>PART-B</b></div>' +
      '</div>' +
      '<div style="width:50%; display:inline-block">' +
      '<div style="font-size:9pt">Coverage starts</div>' +
      '<div><b>' +
      (this.indMedicareParta || '') +
      '</b></div>' +
      '<div><b>' +
      (this.indMedicarePartb || '') +
      '</b></div>' +
      '</div>' +
      '</div>' +
      "<div class='rounded' style='height:20px;background:red'></div>";

    return medicareCard;
  }
}
